/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {initiateOutOfNetworkPayment} from '../api'

export const useMutationInitiateOutOfNetworkPayment = createReactQueryMutationHook('initiateOutOfNetworkPayment', initiateOutOfNetworkPayment)
